export const selectedCountry = {
  placeholder: "Wybierz kraj",
};
